module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [(_vm.headerRow.mode === 'span') ? _c('th', {
    staticClass: "vgt-left-align vgt-row-header",
    attrs: {
      "colspan": _vm.fullColspan
    }
  }, [_vm._t("table-header-row", [(_vm.headerRow.html) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.headerRow.label)
    }
  }) : _c('span', [_vm._v("\n        " + _vm._s(_vm.headerRow.label) + "\n      ")])], {
    row: _vm.headerRow
  })], 2) : _vm._e(), _vm._v(" "), (_vm.headerRow.mode !== 'span' && _vm.lineNumbers) ? _c('th', {
    staticClass: "vgt-row-header"
  }) : _vm._e(), _vm._v(" "), (_vm.headerRow.mode !== 'span' && _vm.selectable) ? _c('th', {
    staticClass: "vgt-row-header"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column, i) {
    return (_vm.headerRow.mode !== 'span') ? _c('th', {
      key: i,
      staticClass: "vgt-row-header",
      class: _vm.getClasses(i, 'td')
    }, [_vm._t("table-header-row", [(!column.html) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.collectFormatted(_vm.headerRow, column, true)) + "\n      ")]) : _vm._e(), _vm._v(" "), (column.html) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.collectFormatted(_vm.headerRow, column, true))
      }
    }) : _vm._e()], {
      row: _vm.headerRow,
      column: column,
      formattedRow: _vm.formattedRow(_vm.headerRow, true)
    })], 2) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae4ac91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js-on/vue-good-table/components/VgtHeaderRow.vue
// module id = 784
// module chunks = 13